import React from "react";
import Carousel from "react-bootstrap/Carousel";

const LoginCarousel = () => {
  return (
    <section className="login_carousel_container">
      <Carousel
        className="login-carousel"
        controls={false}
        indicators={false}
        interval={3000}
        pause={false}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Carousel.Item>
          <img
            className="d-block w-100 img-height"
            // src="/images/login1.png"
            src="/images/home_sec2_img.png"
            alt="First slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 img-height"
            src="/images/login2.png"
            alt="Second slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 img-height"
            src="/images/login3.png"
            alt="Third slide"
          />
        </Carousel.Item>
      </Carousel>
    </section>
  );
};

export default LoginCarousel;
